import { pxToEm } from "../styles";
export var ICON_SIZE = {
  small: 'medium',
  medium: 'medium',
  large: pxToEm(24),
  jumbo: pxToEm(24)
};
export var SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  jumbo: 'jumbo'
};
export var VARIANT = {
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};